import React from 'react';
import { PRESETS, SWITCHES, resolveSwitches } from '../../../lib/events/foundation';

// The automation selector used when an event is started (client app and staff app) and after acceptance (staff).
// `switches` is the company admin's policy per switch: { editable, default, available, visible? }. A switch not built yet (available: false) is not shown at all.
// A client sees only switches the admin shows; a switch the admin locks shows its value and "Set by <company>".
export default function AutomationSelector({ switches = {}, value, onChange, forClient = true, companyName = 'our team', idPrefix = 'ef-auto' }) {
    const preset = value?.preset || 'guided';
    const effective = resolveSwitches(switches, preset, value?.switches || {}, forClient);
    const listed = SWITCHES.filter((s) => switches[s.key] && switches[s.key].available !== false && (!forClient || switches[s.key].visible !== false));
    const setPreset = (next) => onChange({ preset: next, switches: {} });
    const setSwitch = (key, checked) => onChange({ preset, switches: { ...(value?.switches || {}), [key]: checked } });
    return (
        <div className="ef-auto" data-testid="automation-selector">
            <fieldset className="ef-presets">
                <legend className="ef-legend">How much should run automatically?</legend>
                {PRESETS.map((p) => (
                    <label key={p.key} className={`ef-preset${preset === p.key ? ' ef-preset--on' : ''}`} data-testid={`preset-${p.key}`}>
                        <input type="radio" name={`${idPrefix}-preset`} value={p.key} checked={preset === p.key} onChange={() => setPreset(p.key)} />
                        <span className="ef-preset__title">{p.label}</span>
                        <span className="ef-preset__help">{p.help}</span>
                    </label>
                ))}
            </fieldset>
            <fieldset className="ef-switches">
                <legend className="ef-legend">Automations</legend>
                {listed.map((s) => {
                    const rule = switches[s.key];
                    const locked = forClient && !rule.editable;
                    const capped = s.key === 'auto_confirm_rides' && preset !== 'full';
                    const id = `${idPrefix}-${s.key}`;
                    return (
                        <div key={s.key} className="ef-switch" data-testid={`switch-${s.key}`}>
                            <input id={id} type="checkbox" role="switch" checked={Boolean(effective[s.key])} disabled={locked || capped}
                                onChange={(e) => setSwitch(s.key, e.target.checked)} aria-describedby={`${id}-help`} />
                            <label htmlFor={id} className="ef-switch__label">
                                {s.label}
                            </label>
                            <span id={`${id}-help`} className="ef-switch__help">
                                {s.help}
                                {locked && ` Set by ${companyName}.`}
                                {!locked && capped && ' Only with Full automation.'}
                            </span>
                        </div>
                    );
                })}
                {!listed.length && <p className="ef-muted">No automations are offered here. {companyName} handles each step.</p>}
            </fieldset>
            <p className="ef-muted ef-small">Rides never confirm themselves beyond what the transportation company allows; dispatchers can change any ride.</p>
        </div>
    );
}
